import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";

export interface ContactAction {
    type: string;
    payload: Object;
}

@Injectable()
export class ContactActions {

    static GET_CONTACT = "GET_CONTACT";
    static GET_CONTACT_SUCCESS = "GET_CONTACT_SUCCESS";
    static SAVE_CONTACT = "SAVE_CONTACT";
    static UPDATE_CONTACT = "UPDATE_CONTACT";

    constructor(private ngRedux: NgRedux<Object>) { }

    getContact(contactId): void {
        this.ngRedux.dispatch({ type: ContactActions.GET_CONTACT, payload: contactId });
    }

    createContact(contact): void {
        this.ngRedux.dispatch({ type: ContactActions.SAVE_CONTACT, payload: contact });
    }

    updateContact(contact): void {
        this.ngRedux.dispatch({ type: ContactActions.UPDATE_CONTACT, payload: contact });
    }
}
